var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-container',{attrs:{"showNav":true,"clean":true,"background":'calendar'}},[_c('div',[_vm._v(_vm._s(_vm.hello))])])
}
var staticRenderFns = []

export { render, staticRenderFns }